import * as Types from 'src/actions/investment/get/Types';
import {
  GetInvestmentAction,
  GetInvestmentSuccess
} from 'src/actions/investment/get/GetInvestment.actions';
import Investment from 'src/entities/Investment';

export interface GetInvestmentState {
  investment?: Investment;
  loading: boolean;
  error: boolean;
}

export const initialGetInvestmentState: GetInvestmentState = {
  loading: false,
  error: false,
};

export function GetInvestmentReducer(
  state: GetInvestmentState = initialGetInvestmentState,
  action: GetInvestmentAction
): GetInvestmentState {
  switch (action.type) {
    case Types.GET_INVESTMENT_ATTEMPT:
      return { ...state, loading: true, error: false };
    case Types.GET_INVESTMENT_SUCCESS:
      return { ...state, investment: (action as GetInvestmentSuccess).payload, loading: false, error: false };
    case Types.GET_INVESTMENT_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investment/GetInvestmentReducer.tsx